import { currentWallet } from '@cronos-app/wallet';
import { useQueryClient } from '@tanstack/react-query';
import { ensureHasProfile } from '@ui/utils/ensureHasProfile';
import { ensureIsAuthenticated } from '@ui/utils/ensureIsAuthenticated';
import { useRef } from 'react';

import { useIsAuthenticated } from './api/useIsAuthenticated';
import { useGlobalChainLayer } from './useGlobalChainLayer';

export const useInitializeLogin = () => {
  const account = currentWallet.useAccount();
  const chainLayer = useGlobalChainLayer();
  const isConnected = currentWallet.useIsConnectedToSupportedChain(chainLayer);
  const isConnectedRef = useRef(false);
  const accountRef = useRef<string | undefined>();
  const queryClient = useQueryClient();

  const ensureLogin = async () => {
    await ensureIsAuthenticated();
    await ensureHasProfile(() =>
      queryClient.invalidateQueries({
        queryKey: [useIsAuthenticated.queryKey],
      }),
    );
  };

  if (isConnected && !isConnectedRef.current) {
    ensureLogin();
  } else if (account && account !== accountRef.current) {
    ensureLogin();
  }

  isConnectedRef.current = isConnected;
  accountRef.current = account;
};
